import { render, staticRenderFns } from "./BusinessStart.vue?vue&type=template&id=c048d0b8&scoped=true"
import script from "./BusinessStart.vue?vue&type=script&lang=js"
export * from "./BusinessStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c048d0b8",
  null
  
)

export default component.exports